import { render } from "./SendingPanel.vue?vue&type=template&id=793c6ffb&scoped=true"
import script from "./SendingPanel.vue?vue&type=script&lang=js"
export * from "./SendingPanel.vue?vue&type=script&lang=js"

import "./SendingPanel.vue?vue&type=style&index=0&id=793c6ffb&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793c6ffb"]])

export default __exports__